
import { socketUrl } from "../../constants";
import * as signalR from "@microsoft/signalr";

interface PrintRequest {
  labelId: string;
  barCode: string;
  name: string;
}

interface LabelItem {
  id?: number;
  barCode: string;
  name: string;
}


interface RemoveFromPrintPayload {
  /** remove a single item by its index */
  index?: number;
  /** OR remove the first item matching id == value */
  id?: string | number;
  /** which key to compare the id against (default: "id") */
  idKey?: string;
}

export const socketState: any = {
  namespaced: false,
  state: {
    signalRConnection: null,
    connected: false,
    printerNames: [],
    // labels: [],
    labels: [ {id: "1", name: "elso"}], // TODO: ez a demohoz van
    loading: true,
    fetching: false,

    multipleLabelsToPrint: [] as LabelItem[],

  },
  mutations: {
    // load surveyMaterials
    SIGNALR_CONNECTED(state: any, payload: any) {
      state.connected = payload;
    },
    SIGNALR_REFERENCE_SAVE(state: any, payload: any) {
      state.signalRConnection = payload;
    },
    PRINTER_FETCH_SUCCESS(state: any, payload: any) {
      state.printerNames = payload.printers;
      state.labels = payload.labels;
    },

    /** ---------- NEW: labelsToPrint mutations ---------- */
    ADD_TO_PRINT(state: any, payload: LabelItem | LabelItem[]) {
      console.log(`ADD_TO_PRINT: `, payload);
      if (Array.isArray(payload)) {
        state.multipleLabelsToPrint.push(...payload);
      } else {
        state.multipleLabelsToPrint.push(payload);
      }
    },
    REMOVE_FROM_PRINT(state: any, payload: RemoveFromPrintPayload) {
      console.log(`REMOVE_FROM_PRINT: `, payload);
      const { index, id, idKey = "id" } = payload || {};
      if (typeof index === "number" && index >= 0 && index < state.multipleLabelsToPrint.length) {
        state.multipleLabelsToPrint.splice(index, 1);
        return;
      }
      if (id !== undefined) {
        const i = state.multipleLabelsToPrint.findIndex((x: any) => x && x[idKey] === id);
        if (i !== -1) {
          state.multipleLabelsToPrint.splice(i, 1);
        }
      }
    },
    CLEAR_PRINT_QUEUE(state: any) {
      state.multipleLabelsToPrint = [];
    },
  },
  actions: {
    initializeSignalR({commit}) {

      if (socketState.state.signalRConnection != null) {
        console.log("SignalR already connected...");
        return Promise.resolve(socketState.state.signalRConnection);
      }

      return new Promise( (resolve, reject) => {
        const connection = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Trace)
        .withUrl(socketUrl + "/qlmHub", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
            // re-connect after 5000 ms
            return 5000;
          },
        })
        .build();

        connection.onreconnecting(error => {
          console.log("SignalR Re-Connecting...");
          commit("SIGNALR_CONNECTED", false);
        });

        connection.onreconnected(error => {
          console.log("SignalR Reconnected!");
          commit("SIGNALR_CONNECTED", true);

          connection.invoke("GetPrinterInformation")
          .then( res => {
            commit("PRINTER_FETCH_SUCCESS", res);
          })
          .catch(err => {
            console.error(err);
          });
        });

        connection.onclose(() => {
          console.log("SignalR Closed...");
          commit("SIGNALR_CONNECTED", false);
        });

        connection.on("disconnect", error => {
          console.log("SignalR Closed...");
          commit("SIGNALR_CONNECTED", false);
        });

        connection.start().then(res => {
          console.log("SignalR Connected");

          commit("SIGNALR_CONNECTED", true);
          connection.invoke("GetPrinterInformation")
          .then( res2 => {
            commit("PRINTER_FETCH_SUCCESS", res2);
          })
          .catch(err => {
            console.error(err);
          });
        });

        commit("SIGNALR_REFERENCE_SAVE", connection);
        resolve(connection);
      });
    },
    printLabel({ commit }: any, request: PrintRequest) {
      console.log("🔍 [SignalR] printLabel called with request:", request);
      console.log("🔍 [SignalR] Available printers:", socketState.state.printerNames);

      const printerName = socketState.state.printerNames.length > 0 ? socketState.state.printerNames[0] : "valami printer";
      console.log("🔍 [SignalR] Using printer:", printerName);

      return socketState.state.signalRConnection.invoke("PrintLabel", printerName, request)
        .then(result => {
          console.log("✅ [SignalR] PrintLabel success:", result);
          return result;
        })
        .catch(error => {
          console.error("❌ [SignalR] PrintLabel failed:", error);
          console.error("❌ [SignalR] Error details:", {
            message: error.message,
            stack: error.stack,
            request,
            printerName
          });
          throw error;
        });
    },

    /** ---------- NEW: labelsToPrint actions ---------- */
    addToPrint({ commit }: any, labelOrLabels: LabelItem | LabelItem[]) {
      commit("ADD_TO_PRINT", labelOrLabels);
    },
    removeFromPrint({ commit }: any, payload: RemoveFromPrintPayload) {
      commit("REMOVE_FROM_PRINT", payload);
    },
    clearPrintQueue({ commit }: any) {
      commit("CLEAR_PRINT_QUEUE");
    },

    printMultipleLabels({ commit }: any) {

      const payload = socketState.state.multipleLabelsToPrint.map(a => ({
          barCode: a.barCode,
          name: a.name,
          labelId: "1"
        }));

      console.log("🔍 [SignalR] PrintLabelMultiple called with request:", payload);
      console.log("🔍 [SignalR] Available printers:", socketState.state.printerNames);

      const printerName = socketState.state.printerNames.length > 0 ? socketState.state.printerNames[0] : "valami printer";
      console.log("🔍 [SignalR] Using printer:", printerName);

      return socketState.state.signalRConnection.invoke("PrintLabelMultiple", printerName, payload)
        .then(result => {
          console.log("✅ [SignalR] PrintLabelMultiple success:", result);
          return result;
        })
        .catch(error => {
          console.error("❌ [SignalR] PrintLabelMultiple failed:", error);
          console.error("❌ [SignalR] Error details:", {
            message: error.message,
            stack: error.stack,
            payload,
            printerName
          });
          throw error;
        });
    },
  }
};
